export default __webpack_public_path__ + "static/19-cccd93a24e2c7eeb7ef39a21d5652c5e.png";